module.exports = __webpack_public_path__ + "public/images/stand-menu-back.525b6cd5d4b00ed9a1032919f1eb82d5.svg";